module.exports = __webpack_public_path__ + "media/images/flags/64/Russia-84e2f6434cfb27b6af1b4fa883d31af4.png";